import { WHATSAPP_NUMBER } from '@/config/site';

export const PHONE_DISPLAY = '(81) 98203-0285';
export const PHONE_TEL = '+5581982030285';

export const WHATSAPP_BASE = `https://wa.me/${WHATSAPP_NUMBER}`;

export const WHATSAPP_GENERIC_MESSAGE = encodeURIComponent(
  'Olá! Vim pelo site (Divisórias Corporativas) e gostaria de falar com um especialista sobre um projeto de divisórias para minha empresa.'
);